import { Component, OnInit, HostListener } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { DecodeTicketService } from '../../shared/services/decode-ticket.service';
import { KeyboardServiceService } from '../../shared/keyboard-service/keyboard-service.service';
import { ValidationService } from '../../shared/services/validation.service';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-enter-email',
  templateUrl: './enter-email.component.html',
  styleUrls: ['./enter-email.component.scss']
})
export class EnterEmailComponent implements OnInit {
  showSpinner: boolean = false;
  fullString: String = '';
  previous: String = null;
  scanComplete: Boolean = false;
  enterEmail: boolean = false;

  signup = {
    email: ''
  }

  constructor (
    private keyboardSvc: KeyboardServiceService,
    private dataSvc: DatabusService,
    private decoder: DecodeTicketService,
    private validate: ValidationService,
    private idle: Idle,
    private router: Router ) { 
      this.keyboardSvc.currentModel = 'email';
    }

  SetModelFromKeyboard (val) {
    let currentModel = this.keyboardSvc.getCurrentModel();

    if(val === 'DELETE') {
      this.signup[currentModel] = this.keyboardSvc.deleteValue(this.signup[currentModel]);
    } else {
      this.signup[currentModel] = this.signup[currentModel] + val;
    }
  }

  isCurrent (name) {
    return this.keyboardSvc.currentModel === name;
  }
  
  RouteToSignup () {
    this.router.navigate(['/addprofile']);
  }  

  CancelEmail () {
    this.router.navigate(['/scanticket']);
  }

  EnterEmail () {
    this.showSpinner = true;
    if(this.signup.email && this.signup.email !== '') {
      this.dataSvc.currentEmail = this.signup.email;
      if(this.dataSvc.currentTicket !== '') {
        //check for email on account here
        this.validate.checkEmail(this.signup.email)
        .then((results) => {
          if(results.customer_id !== "-1") {
            this.AssignTicket();
          } else {
            this.router.navigate(['/addprofile']);
          }
        })
        .catch((err) => {
          this.showSpinner = false;
        })
        
      } else {
        this.showSpinner = false;
        this.router.navigate(['/scanticket']);
      }
    }
  }

  AssignTicket() {
    //if (this.dataSvc.currentEmail === '' || this.dataSvc.currentTicket.code) {
    //  console.warn('Missed email or code, email=' + this.dataSvc.currentEmail + ' code=' + this.dataSvc.currentTicket.code);
    //  this.router.navigate(['/scanticket']);
    //}

    let ticket = {
      email: this.dataSvc.currentEmail,
      code: this.dataSvc.currentTicket.code
    }
    this.validate.assignTicketAccount(ticket)
    .then((results) => {
      if(results.status === "204") {
        this.dataSvc.redeemValue = results.value;
        this.router.navigate(['/success']);
      }
      if(results.status === "409") {
        this.dataSvc.errorMessage = results.message;
        this.router.navigate(['/invalid']);
      }
      //console.warn('Unexpected response from server');
      //console.warn(results);
      //this.router.navigate(['/scanticket']);
    })    
  }

  ngOnInit() {
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
    this.keyboardSvc.currentModel = 'email';
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/enter-email/enter-email.component.ts